import { Component, OnInit, Input } from '@angular/core';
import { DocumentRawData } from '../../../models/document-raw-data.model';
import { PreviewDocumentModel } from '../../../models/event-poe-document.model';
import {
  FileContentModel,
  PreviewFileTypes
} from '../../../models/file-content.model';
import { DocumentPreviewService } from '../../services/document-preview.service';
import { CommonSharedModule } from '../../common/shared.module';
import { PreviewDocComponent } from '../preview-doc/preview-doc.component';

@Component({
  selector: 'app-preview-content',
  templateUrl: './preview-content.component.html',
  styleUrls: ['./preview-content.component.scss'],
  standalone: true,
  imports: [CommonSharedModule, PreviewDocComponent]
})
export class PreviewContentComponent implements OnInit {
  isDocumentPreviewLoading = false;
  fileContentModel!: FileContentModel;
  @Input() documentPreviewData!: PreviewDocumentModel;
  @Input() documentRawData!: DocumentRawData[];

  constructor(private previewDocService: DocumentPreviewService) {}

  ngOnInit() {
    this.loadPreviewFile();
  }

  loadPreviewFile() {
    this.isDocumentPreviewLoading = true;
    const extension = this.documentPreviewData.fileName?.split('.').pop();
    let fileContentUrl = '';
    if (extension?.toLowerCase() === 'pdf') {
      this.previewDocService
        .getPreviewFileContent(this.documentPreviewData)
        .subscribe(
          downloadFile => {
            const file = new Blob([downloadFile], { type: 'application/pdf' });
            this.fileContentModel = new FileContentModel();
            fileContentUrl = URL.createObjectURL(file);
            this.fileContentModel.previewFileType = PreviewFileTypes.pdf;
            this.fileContentModel.fileFound = true;
            this.fileContentModel.fileUrl = fileContentUrl;
            this.isDocumentPreviewLoading = false;
          },
          () => {
            this.isDocumentPreviewLoading = false;
          }
        );
    } else {
      this.previewDocService.getFileSasUrl(this.documentPreviewData).subscribe(
        sasUrl => {
          fileContentUrl = sasUrl;
          this.fileContentModel = new FileContentModel();
          if (
            extension?.toLowerCase() === 'jpeg' ||
            extension?.toLowerCase() === 'png' ||
            extension?.toLowerCase() === 'jpg' ||
            extension?.toLowerCase() === 'bmp' ||
            extension?.toLowerCase() === 'gif'
          ) {
            this.fileContentModel.previewFileType = PreviewFileTypes.image;
          } else if (
            extension?.toLowerCase() === 'doc' ||
            extension?.toLowerCase() === 'docx'
          ) {
            this.fileContentModel.previewFileType = PreviewFileTypes.doc;
          } else if (
            extension?.toLowerCase() === 'ppt' ||
            extension?.toLowerCase() === 'pptx'
          ) {
            this.fileContentModel.previewFileType = PreviewFileTypes.ppt;
          } else {
            this.fileContentModel.previewFileType =
              PreviewFileTypes.unsupported;
          }

          this.fileContentModel.fileFound = true;
          this.fileContentModel.fileUrl = fileContentUrl;
          this.isDocumentPreviewLoading = false;
        },
        () => {
          this.isDocumentPreviewLoading = false;
        }
      );
    }
  }
}
